import React from "react";
import { Button } from "./ui/button";
import { Download, Loader2, Lock } from "lucide-react";

/**
 * Download-as-PDF button for generated model answers/essays.
 * `locked` (non-PRO) renders an amber lock variant; the parent's onClick
 * decides whether to download or prompt an upgrade.
 */
export const DownloadAnswerButton = ({ locked = false, busy = false, onClick, testid = "download-answer-btn", label = "Download PDF" }) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    onClick={onClick}
    disabled={busy}
    data-testid={locked ? `${testid}-locked` : testid}
    className={
      locked
        ? "border-amber-300 text-amber-700 hover:bg-amber-50"
        : "border-orange-300 text-orange-700 hover:bg-orange-50"
    }
  >
    {busy ? (
      <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />
    ) : locked ? (
      <Lock className="w-4 h-4 mr-1.5" />
    ) : (
      <Download className="w-4 h-4 mr-1.5" />
    )}
    {locked ? `${label} (PRO)` : label}
  </Button>
);
